import { useContext } from 'react';
import { ConfigurationContext } from '../ContextProviders/ConfigurationProvider';
import getItemRules from './getItemRules';
import useConfigurationChanges from '../Hooks/useConfigurationChanges';

export default function useItemRules() {
  const warehouseConfiguration = useContext(ConfigurationContext);
  const configurationData = useConfigurationChanges(warehouseConfiguration);
  return getItemRules(configurationData);
}
